export class ChartTAPData {
  public constructor (
    readonly year: string,
    readonly month: string,
    readonly name: string,
    readonly sum: string,
  ) {}

  static createListFromResponse (data: any): Array<ChartTAPData> {
    return data.map((item: any) => {
      return new ChartTAPData(
        item.Jahr,
        item.Monat,
        `${item.ProduktNummer} ${item.ProduktBezeichnung}`,
        item.Sum_Betrag
      )
    })
  }
}
